export const APP_UUID = process.env.NODE_ENV === 'production' ? 'd57f63f8-338b-4ad8-b15a-667baf309606' : '8a28e34f-2b33-491f-9832-c895e1453cf2';
export const COOKIE_DOMAIN = process.env.NODE_ENV === 'production' ? '.saffronapp.co' : 'localhost';
export const API_URL = process.env.API_URL || 'https://api.saffronapp.co/api';
export const TIME_CLOCK_APP_URL = process.env.NODE_ENV === 'production' ? 'http://staging.timeclock.saffronapp.co' : 'http://saffron.local/timeclock';
export const AUTH_HEADERS = ['access-token', 'token-type', 'client', 'expiry', 'uid'];
export const DEFAULT_TZ = 'America/Detroit';
export const DEFAULT_LOCALE = 'en';
export const DEFAULT_LANG = 'en';
export const LOG_EXCEPTIONS = process.env.NODE_ENV === 'production' ? true : false;  // eslint-disable-line no-unneeded-ternary
export const SENTRY_DNS = 'https://742649e332dc45179a5eda120bb286a1@sentry.io/292698';
export const AWS_ACCESS_KEY_ID = process.env.AWS_ACCESS_KEY_ID;
export const AWS_SECRET_ACCESS_KEY = process.env.AWS_SECRET_ACCESS_KEY;



// WEBPACK FOOTER //
// ./src/constants.js